"use client";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Textinput from "@/components/ui/Textinput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useRouter } from "next/navigation";
import Checkbox from "@/components/ui/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { handleRegister } from "./store";
import useAuthInfo from "@/store/auth";
import { AjaxGetAnon, AjaxPostAnon } from "@/util/Ajax";
import md5 from "md5";
import Link from "next/link";
import { Button } from "@/components/ui/ButtonShadcn";
import { useSearchParams } from "next/navigation";
import Swal from "sweetalert2";
import GoogleSignIn from "./google-sign-in";
const schema = yup
  .object({
    name: yup.string().required("Name is Required"),
    email: yup.string().email("Invalid email").required("Email is Required"),
    password: yup
      .string()
      .min(6, "Password must be at least 8 characters")
      .max(20, "Password shouldn't be more than 20 characters")
      .required("Please enter password"),
    // confirm password
    confirmpassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  })
  .required();

const RegForm = ({
  showRegisterButton = true,
  onRegisterSuccess = null,
  isCheckOut = false,
  isBorrowForm = false,
  onSuccess = null
}) => {
  const searchParams = useSearchParams();
  const referralCode = searchParams.get("referralCode");
  const dispatch = useDispatch();
  const authData = useAuthInfo((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [showReferralInput, setShowReferralInput] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });

  useEffect(() => {
    if (referralCode) {
      setValue("referralCode", referralCode);
      setShowReferralInput(true);
    }
  }, [referralCode, setValue]);

  const router = useRouter();

  const onSubmit = async (data) => {
    setIsLoading(true);
    if(data.name.includes("50")){
      return;
    }
    if(data.surname == "Go"){
      return;
    }
    if(data.referralCode && !await CheckIfReferalCodeIsValid(data.referralCode)){
      Swal.fire({
        icon: "error",
        title: "Invalid Referral Code",
        text: "Please enter a valid referral code"
      })
      setIsLoading(false);
      return
    }

    var res = await AjaxPostAnon(`Authentication/Register`, {
      firstname: data.name,
        email: data.email,
      passwordHash: md5(data.confirmpassword),
      referalCode: data.referralCode?.toUpperCase(),
    });
    if (res.data) {
      authData.updateAuthStore(res.data);
      if(onSuccess != null){
        return onSuccess();
      }
      if (onRegisterSuccess != null) {
        setIsLoading(false);
        return onRegisterSuccess(res.data);
      }
      setTimeout(() => {
        router.push("/");
      }, 100);
    } else {
      toast.error("Invalid credentials", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsLoading(false);
    }
  };

  const CheckIfReferalCodeIsValid = async (code) => {
    var res = await AjaxGetAnon(`Referral/CheckCode/${code?.toUpperCase()}`);
    if (res.data) {
      return true;
    } else {
      return false;
    }
  };

  const onGoogleAuthenticated = (data) => {
    authData.updateAuthStore(data);
    if (onSuccess != null) {
      onSuccess();
      return;
    }
    if (onRegisterSuccess != null) {
      onRegisterSuccess(data);
      return;
    }
    router.push("/");
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-5 ">
      <GoogleSignIn
        onAuthenticated={onGoogleAuthenticated}
        text="signup_with"
        showConsentNotice
      />
      <Textinput
        name="name"
        label="name"
        type="text"
        placeholder=" Enter your name"
        register={register}
        error={errors.name}
      />
      <Textinput
        name="email"
        label="email"
        type="email"
        placeholder=" Enter your email"
        register={register}
        error={errors.email}
      />
      <Textinput
        name="password"
        label="password"
        type="password"
        placeholder=" Enter your password"
        register={register}
        error={errors.password}
      />
      <Textinput
        name="confirmpassword"
        label="Confirm Password"
        type="password"
        placeholder="Confirm your password"
        register={register}
        error={errors.confirmpassword}
      />
      <Checkbox
        label="I have a referal code"
        value={showReferralInput}
        onChange={() => setShowReferralInput(!showReferralInput)}
      />
      {showReferralInput && (
        <Textinput
          name="referralCode"
          label="Referral Code"
          type="text"
          placeholder="Enter a referral code"
          register={register}
          disabled={referralCode}
          error={errors.referralCode}
        />
      )}
      {showRegisterButton && (
        <Button
          text="Create an account"
          type="submit"
          className="bg-primary-500 text-white w-full mt-4"
          isLoading={isLoading}
          disabled={isLoading}
        />
      )}
      {!showRegisterButton && isCheckOut && (
        <Button
          icon="heroicons-outline:shopping-cart"
          text="Proceed To Checkout"
          type="submit"
          className="bg-primary-500 text-white w-full mt-4"
          isLoading={isLoading}
          disabled={isLoading}
        />
      )}
      {!showRegisterButton && isBorrowForm && (
        <Button
          icon="heroicons-outline:banknotes"
          text="Borrow"
          type="submit"
          className="bg-primary-500 text-white w-full mt-4"
          isLoading={isLoading}
          disabled={isLoading}
        />
      )}
    </form>
  );
};

export default RegForm;
